import React, { useEffect } from "react";
import styled from "styled-components"

import Layout from "../components/layout"
import Container from "../components/container"
import PageHeader from "../components/header-page"

//<link href="//cdn-images.mailchimp.com/embedcode/classic-081711.css" rel="stylesheet" type="text/css">

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

function SubscribePage(props) {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/subscribe", title: "Subscribe"});
  }, []);

  return (
    <Layout page="subscribe" title="Subscribe">
      <Container>
        <PageHeader>Subscribe</PageHeader>
        <h3>Sign up for our email list to learn about our shows and upcoming events.</h3>

        <div id="mc_embed_signup">
          <form action="//marshallartistsseries.us9.list-manage.com/subscribe/post?u=410864467c11797255a46441b&amp;id=d7173ec74e" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" novalidate="" style={{paddingLeft: "0px"}}>
            <div id="mc_embed_signup_scroll">
              <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
              <div class="mc-field-group">
                <label for="mce-EMAIL">Email Address  <span class="asterisk">*</span></label>
                <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" />
              </div>
              <div class="mc-field-group">
                <label for="mce-FNAME">First Name </label>
                <input type="text" value="" name="FNAME" class="" id="mce-FNAME" />
              </div>
              <div class="mc-field-group">
                <label for="mce-LNAME">Last Name </label>
                <input type="text" value="" name="LNAME" class="" id="mce-LNAME" />
              </div>
              <div class="mc-field-group input-group">
                <strong>Email Format </strong>
                <ul>
                  <li><input type="radio" value="html" name="EMAILTYPE" id="mce-EMAILTYPE-0" /><label for="mce-EMAILTYPE-0">html</label></li>
                  <li><input type="radio" value="text" name="EMAILTYPE" id="mce-EMAILTYPE-1" /><label for="mce-EMAILTYPE-1">text</label></li>
                </ul>
              </div>
              <div id="mce-responses" class="clear">
                <div class="response" id="mce-error-response" style={{display: "none"}}></div>
                <div class="response" id="mce-success-response" style={{display: "none"}}></div>
              </div>   
              <div style={{position: "absolute", left: "-5000px"}}>
                <input type="text" name="b_410864467c11797255a46441b_d7173ec74e" tabindex="-1" value="" />
              </div>
              <div class="clear">
                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button" />
              </div>
            </div>
          </form>
        </div>

        <br />
        <br />

      </Container>
    </Layout>
  );
}

export default SubscribePage;